import { MinimalPairs } from './model';

const MasonPairs: MinimalPairs = {
    /* #region /ɪ/ vs /i:/ */
    "shit-sheet": {
        left: {
            id: "shit",
            label: "shit",
            phoneme: "ɪ"
        },
        right: {
            id: "sheet",
            label: "sheet",
            phoneme: "i:"
        }
    },
    "lip-leap": {
        left: {
            id: "lip",
            label: "lip",
            phoneme: "ɪ"
        },
        right: {
            id: "leap",
            label: "leap",
            phoneme: "i:"
        }
    },
    "rich-reach": {
        left: {
            id: "rich",
            label: "rich",
            phoneme: "ɪ"
        },
        right: {
            id: "reach",
            label: "reach",
            phoneme: "i:"
        }
    },
    "still-steal": {
        left: {
            id: "still",
            label: "still",
            phoneme: "ɪ"
        },
        right: {
            id: "steal",
            label: "steal",
            phoneme: "i:"
        }
    },
    "fist-feast": {
        left: {
            id: "fist",
            label: "fist",
            phoneme: "ɪ"
        },
        right: {
            id: "feast",
            label: "feast",
            phoneme: "i:"
        }
    },
    "fit-feet": {
        left: {
            id: "fit",
            label: "fit",
            phoneme: "ɪ"
        },
        right: {
            id: "feet",
            label: "feet",
            phoneme: "i:"
        }
    },
    "slip-sleep": {
        left: {
            id: "slip",
            label: "slip",
            phoneme: "ɪ"
        },
        right: {
            id: "sleep",
            label: "sleep",
            phoneme: "i:"
        }
    },
    "sin-seen": {
        left: {
            id: "sin",
            label: "sin",
            phoneme: "ɪ"
        },
        right: {
            id: "seen",
            label: "seen",
            phoneme: "i:"
        }
    },
    "lick-leak": {
        left: {
            id: "lick",
            label: "lick",
            phoneme: "ɪ"
        },
        right: {
            id: "leak",
            label: "leak",
            phoneme: "i:"
        }
    },
    "pill-peal": {
        left: {
            id: "pill",
            label: "pill",
            phoneme: "ɪ"
        },
        right: {
            id: "peal",
            label: "peal",
            phoneme: "i:"
        }
    },
    "gin-gene": {
        left: {
            id: "gin",
            label: "gin",
            phoneme: "ɪ"
        },
        right: {
            id: "gene",
            label: "gene",
            phoneme: "i:"
        }
    },
    "pick-peak": {
        left: {
            id: "pick",
            label: "pick",
            phoneme: "ɪ"
        },
        right: {
            id: "peak",
            label: "peak",
            phoneme: "i:"
        }
    },
    "rip-reap": {
        left: {
            id: "rip",
            label: "rip",
            phoneme: "ɪ"
        },
        right: {
            id: "reap",
            label: "reap",
            phoneme: "i:"
        }
    },
    /* #endregion */

    /* #region /ɑ/ vs /ʌ/ */
    "got-gut": {
        left: {
            id: "got",
            label: "got",
            phoneme: "ɑ"
        },
        right: {
            id: "gut",
            label: "gut",
            phoneme: "ʌ"
        }
    },
    "pot-put": {
        left: {
            id: "pot",
            label: "pot",
            phoneme: "ɑ"
        },
        right: {
            id: "put",
            label: "put",
            phoneme: "ʌ"
        }
    },
    "watt-what": {
        left: {
            id: "watt",
            label: "watt",
            phoneme: "ɑ"
        },
        right: {
            id: "what",
            label: "what",
            phoneme: "ʌ"
        }
    },
    "sock-suck": {
        left: {
            id: "sock",
            label: "sock",
            phoneme: "ɑ"
        },
        right: {
            id: "suck",
            label: "suck",
            phoneme: "ʌ"
        }
    },
    "shot-shut": {
        left: {
            id: "shot",
            label: "shot",
            phoneme: "ɑ"
        },
        right: {
            id: "shut",
            label: "shut",
            phoneme: "ʌ"
        }
    },
    "hot-hut": {
        left: {
            id: "hot",
            label: "hot",
            phoneme: "ɑ"
        },
        right: {
            id: "hut",
            label: "hut",
            phoneme: "ʌ"
        }
    },
    "rob-rub": {
        left: {
            id: "rob",
            label: "rob",
            phoneme: "ɑ"
        },
        right: {
            id: "rub",
            label: "rub",
            phoneme: "ʌ"
        }
    },
    "rot-rut": {
        left: {
            id: "rot",
            label: "rot",
            phoneme: "ɑ"
        },
        right: {
            id: "rut",
            label: "rut",
            phoneme: "ʌ"
        }
    },
    "not-nut": {
        left: {
            id: "not",
            label: "not",
            phoneme: "ɑ"
        },
        right: {
            id: "nut",
            label: "nut",
            phoneme: "ʌ"
        }
    },
    /* #endregion */

    /* #region /ɑ/ vs /æ/ */
    "top-tap": {
        left: {
            id: "top",
            label: "top",
            phoneme: "ɑ"
        },
        right: {
            id: "tap",
            label: "tap",
            phoneme: "æ"
        }
    },
    "hot-hat": {
        left: {
            id: "hot",
            label: "hot",
            phoneme: "ɑ"
        },
        right: {
            id: "hat",
            label: "hat",
            phoneme: "æ"
        }
    },
    "rock-rack": {
        left: {
            id: "rock",
            label: "rock",
            phoneme: "ɑ"
        },
        right: {
            id: "rack",
            label: "rack",
            phoneme: "æ"
        }
    },
    "bog-bag": {
        left: {
            id: "bog",
            label: "bog",
            phoneme: "ɑ"
        },
        right: {
            id: "bag",
            label: "bag",
            phoneme: "æ"
        }
    },
    "fog-fag": {
        left: {
            id: "fog",
            label: "fog",
            phoneme: "ɑ"
        },
        right: {
            id: "fag",
            label: "fag",
            phoneme: "æ"
        }
    },
    "gob-gab": {
        left: {
            id: "gob",
            label: "gob",
            phoneme: "ɑ"
        },
        right: {
            id: "gab",
            label: "gab",
            phoneme: "æ"
        }
    },
    "mop-map": {
        left: {
            id: "mop",
            label: "mop",
            phoneme: "ɑ"
        },
        right: {
            id: "map",
            label: "map",
            phoneme: "æ"
        }
    },
    "sock-sack": {
        left: {
            id: "sock",
            label: "sock",
            phoneme: "ɑ"
        },
        right: {
            id: "sack",
            label: "sack",
            phoneme: "æ"
        }
    },
    "lost-last": {
        left: {
            id: "lost",
            label: "lost",
            phoneme: "ɑ"
        },
        right: {
            id: "last",
            label: "last",
            phoneme: "æ"
        }
    },
    "pot-pat": {
        left: {
            id: "pot",
            label: "pot",
            phoneme: "ɑ"
        },
        right: {
            id: "pat",
            label: "pat",
            phoneme: "æ"
        }
    },
    "flop-flap": {
        left: {
            id: "flop",
            label: "flop",
            phoneme: "ɑ"
        },
        right: {
            id: "flap",
            label: "flap",
            phoneme: "æ"
        }
    },
    "lob-lab": {
        left: {
            id: "lob",
            label: "lob",
            phoneme: "ɑ"
        },
        right: {
            id: "lab",
            label: "lab",
            phoneme: "æ"
        }
    },
    /* #endregion */

    /* #region /æ/ vs /e/ */
    "bat-bet": {
        left: {
            id: "bat",
            label: "bat",
            phoneme: "æ"
        },
        right: {
            id: "bet",
            label: "bet",
            phoneme: "e"
        }
    },
    "sad-said": {
        left: {
            id: "sad",
            label: "sad",
            phoneme: "æ"
        },
        right: {
            id: "said",
            label: "said",
            phoneme: "e"
        }
    },
    "had-head": {
        left: {
            id: "had",
            label: "had",
            phoneme: "æ"
        },
        right: {
            id: "head",
            label: "head",
            phoneme: "e"
        }
    },
    "cattle-kettle": {
        left: {
            id: "cattle",
            label: "cattle",
            phoneme: "æ"
        },
        right: {
            id: "kettle",
            label: "kettle",
            phoneme: "e"
        }
    },
    "lad-lead": {
        left: {
            id: "lad",
            label: "lad",
            phoneme: "æ"
        },
        right: {
            id: "lead",
            label: "lead",
            phoneme: "e"
        }
    },
    "gas-guess": {
        left: {
            id: "gas",
            label: "gas",
            phoneme: "æ"
        },
        right: {
            id: "guess",
            label: "guess",
            phoneme: "e"
        }
    },
    "slapped-slept": {
        left: {
            id: "slapped",
            label: "slapped",
            phoneme: "æ"
        },
        right: {
            id: "slept",
            label: "slept",
            phoneme: "e"
        }
    },
    "past-pest": {
        left: {
            id: "past",
            label: "past",
            phoneme: "æ"
        },
        right: {
            id: "pest",
            label: "pest",
            phoneme: "e"
        }
    },
    /* #endregion */

    /* #region /ʊ/ vs /u:/ */
    "stood-stewed": {
        left: {
            id: "stood",
            label: "stood",
            phoneme: "ʊ"
        },
        right: {
            id: "stewed",
            label: "stewed",
            phoneme: "u:"
        },
    },
    "look-luke": {
        left: {
            id: "look",
            label: "look",
            phoneme: "ʊ"
        },
        right: {
            id: "luke",
            label: "luke",
            phoneme: "u:"
        },
    },
    "wood-wooed": {
        left: {
            id: "wood",
            label: "wood",
            phoneme: "ʊ"
        },
        right: {
            id: "wooed",
            label: "wooed",
            phoneme: "u:"
        },
    },
    "pull-pool": {
        left: {
            id: "pull",
            label: "pull",
            phoneme: "ʊ"
        },
        right: {
            id: "pool",
            label: "pool",
            phoneme: "u:"
        },
    },
    "soot-suit": {
        left: {
            id: "soot",
            label: "soot",
            phoneme: "ʊ"
        },
        right: {
            id: "suit",
            label: "suit",
            phoneme: "u:"
        },
    },
    "cookie-kooky": {
        left: {
            id: "cookie",
            label: "cookie",
            phoneme: "ʊ"
        },
        right: {
            id: "kooky",
            label: "kooky",
            phoneme: "u:"
        },
    },
    "toll-tool": {
        left: {
            id: "toll",
            label: "toll",
            phoneme: "ʊ"
        },
        right: {
            id: "tool",
            label: "tool",
            phoneme: "u:"
        },
    },
    /* #endregion */

    /* #region /æ/ vs /oʊ/ */
    "ram-roam": {
        left: {
            id: "ram",
            label: "ram",
            phoneme: "æ"
        },
        right: {
            id: "roam",
            label: "roam",
            phoneme: "oʊ"
        },
    },
    "bat-boat": {
        left: {
            id: "bat2",
            label: "bat",
            phoneme: "æ"
        },
        right: {
            id: "boat",
            label: "boat",
            phoneme: "oʊ"
        },
    },
    "ham-home": {
        left: {
            id: "ham",
            label: "ham",
            phoneme: "æ"
        },
        right: {
            id: "home",
            label: "home",
            phoneme: "oʊ"
        },
    },
    "sack-soak": {
        left: {
            id: "sack2",
            label: "sack",
            phoneme: "æ"
        },
        right: {
            id: "soak",
            label: "soak",
            phoneme: "oʊ"
        },
    },
    "cat-coat": {
        left: {
            id: "cat2",
            label: "cat",
            phoneme: "æ"
        },
        right: {
            id: "coat",
            label: "coat",
            phoneme: "oʊ"
        },
    },
    /* #endregion */

    /* #region /ɑ/ vs /oʊ/ */
    "nod-node": {
        left: {
            id: "nod",
            label: "nod",
            phoneme: "ɑ"
        },
        right: {
            id: "node",
            label: "node",
            phoneme: "oʊ"
        },
    },
    "mop-mope": {
        left: {
            id: "mop2",
            label: "mop",
            phoneme: "ɑ"
        },
        right: {
            id: "mope",
            label: "mope",
            phoneme: "oʊ"
        }
    },
    "cod-code": {
        left: {
            id: "cod",
            label: "cod",
            phoneme: "ɑ"
        },
        right: {
            id: "code",
            label: "code",
            phoneme: "oʊ"
        }
    },
    /* #endregion */

    /* #region /ɔ/ vs /ʌ/ */
    "bought-but": {
        left: {
            id: "bought",
            label: "bought",
            phoneme: "ɔ"
        },
        right: {
            id: "but",
            label: "but",
            phoneme: "ʌ"
        }
    },
    "hall-hull": {
        left: {
            id: "hall",
            label: "hall",
            phoneme: "ɔ"
        },
        right: {
            id: "hull",
            label: "hull",
            phoneme: "ʌ"
        }
    },
    "caught-cut": {
        left: {
            id: "caught",
            label: "caught",
            phoneme: "ɔ"
        },
        right: {
            id: "cut",
            label: "cut",
            phoneme: "ʌ"
        }
    },
    "daughter-dutter": {
        left: {
            id: "daughter",
            label: "daughter",
            phoneme: "ɔ"
        },
        right: {
            id: "dutter",
            label: "dutter",
            phoneme: "ʌ"
        }
    },
    "mall-mull": {
        left: {
            id: "mall2",
            label: "mall",
            phoneme: "ɔ"
        },
        right: {
            id: "mull",
            label: "mull",
            phoneme: "ʌ"
        },
    },
    "gall-gull": {
        left: {
            id: "gall",
            label: "gall",
            phoneme: "ɔ"
        },
        right: {
            id: "gull",
            label: "gull",
            phoneme: "ʌ"
        }
    },
    /* #endregion */

    /* #region /ɔ/ vs /ʊ/ */
    "fall-full": {
        left: {
            id: "topquark_fall",
            label: "fall",
            phoneme: "ɔ"
        },
        right: {
            id: "topquark_full",
            label: "full",
            phoneme: "ʊ"
        }
    },
    /* #endregion */

    /* #region /ɔ/ vs /oʊ/ */
    "ball-bowl": {
        left: {
            id: "ball",
            label: "ball",
            phoneme: "ɔ"
        },
        right: {
            id: "bowl",
            label: "bowl",
            phoneme: "oʊ"
        },
    },
    "wrought-wrote": {
        left: {
            id: "wrought",
            label: "wrought",
            phoneme: "ɔ"
        },
        right: {
            id: "wrote",
            label: "wrote",
            phoneme: "oʊ"
        },
    },
    "raw-row": {
        left: {
            id: "raw",
            label: "raw",
            phoneme: "ɔ"
        },
        right: {
            id: "row",
            label: "row",
            phoneme: "oʊ"
        },
    },
    "law-load": {
        left: {
            id: "law",
            label: "law",
            phoneme: "ɔ"
        },
        right: {
            id: "load",
            label: "load",
            phoneme: "oʊ"
        },
    },
    "called-cold": {
        left: {
            id: "called",
            label: "called",
            phoneme: "ɔ"
        },
        right: {
            id: "cold",
            label: "cold",
            phoneme: "oʊ"
        },
    },
    "ought-oat": {
        left: {
            id: "ought",
            label: "ought",
            phoneme: "ɔ"
        },
        right: {
            id: "oat",
            label: "oat",
            phoneme: "oʊ"
        },
    },
    "tall-toll": {
        left: {
            id: "tall",
            label: "tall",
            phoneme: "ɔ"
        },
        right: {
            id: "toll",
            label: "toll",
            phoneme: "oʊ"
        }
    },
    /* #endregion */

    /* #region /æ/ vs /aʊ/ */
    "sand-sound": {
        left: {
            id: "sand",
            label: "sand",
            phoneme: "æ"
        },
        right: {
            id: "sound",
            label: "sound",
            phoneme: "aʊ"
        },
    },
    /* #endregion */

    /* #region /ɔ/ vs /aʊ/ */
    "dawn-down": {
        left: {
            id: "dawn",
            label: "dawn",
            phoneme: "ɔ"
        },
        right: {
            id: "down",
            label: "down",
            phoneme: "aʊ"
        },
    },
    "moss-mouse": {
        left: {
            id: "moss",
            label: "moss",
            phoneme: "ɔ"
        },
        right: {
            id: "mouse",
            label: "mouse",
            phoneme: "aʊ"
        },
    },
    "brawn-brown": {
        left: {
            id: "brawn",
            label: "brawn",
            phoneme: "ɔ"
        },
        right: {
            id: "brown",
            label: "brown",
            phoneme: "aʊ"
        },
    },
    "ought-out": {
        left: {
            id: "ought",
            label: "ought",
            phoneme: "ɔ"
        },
        right: {
            id: "out",
            label: "out",
            phoneme: "aʊ"
        },
    },
    "fall-foul": {
        left: {
            id: "fall",
            label: "fall",
            phoneme: "ɔ"
        },
        right: {
            id: "foul",
            label: "foul",
            phoneme: "aʊ"
        },
    },
    "soar-sour": {
        left: {
            id: "soar",
            label: "soar",
            phoneme: "ɔ"
        },
        right: {
            id: "sour",
            label: "sour",
            phoneme: "aʊ"
        },
    },
    /* #endregion */

    /* #region /ɑ/ vs /aʊ/ */
    "rot-route": {
        left: {
            id: "rot",
            label: "rot",
            phoneme: "ɑ"
        },
        right: {
            id: "route",
            label: "route",
            phoneme: "aʊ"
        },
    },
    "pond-pound": {
        left: {
            id: "pond",
            label: "pond",
            phoneme: "ɑ"
        },
        right: {
            id: "pound",
            label: "pound",
            phoneme: "aʊ"
        },
    },
    "spot-spout": {
        left: {
            id: "spot",
            label: "spot",
            phoneme: "ɑ"
        },
        right: {
            id: "spout",
            label: "spout",
            phoneme: "aʊ"
        },
    },
    "shot-shout": {
        left: {
            id: "shot",
            label: "shot",
            phoneme: "ɑ"
        },
        right: {
            id: "shout",
            label: "shout",
            phoneme: "aʊ"
        },
    },
    /* #endregion */

    /* #region /ɔ/ vs /aɪ/ */
    "mall-mile": {
        left: {
            id: "mall",
            label: "mall",
            phoneme: "ɔ"
        },
        right: {
            id: "mile",
            label: "mile",
            phoneme: "aɪ"
        },
    },
    "fought-fight": {
        left: {
            id: "fought",
            label: "fought",
            phoneme: "ɔ"
        },
        right: {
            id: "fight",
            label: "fight",
            phoneme: "aɪ"
        },
    },
    "wrought-right": {
        left: {
            id: "wrought",
            label: "wrought",
            phoneme: "ɔ"
        },
        right: {
            id: "right",
            label: "right",
            phoneme: "aɪ"
        },
    },
    /* #endregion */

    /* #region /ɪ/ vs /aɪ/ */
    "heat-height": {
        left: {
            id: "heat",
            label: "heat",
            phoneme: "ɪ"
        },
        right: {
            id: "height",
            label: "height",
            phoneme: "aɪ"
        },
    },
    /* #endregion */

    /* #region /i:/ vs /aɪ/ */
    "ream-rhyme": {
        left: {
            id: "ream",
            label: "ream",
            phoneme: "i:"
        },
        right: {
            id: "rhyme",
            label: "rhyme",
            phoneme: "aɪ"
        },
    },
    "lead-lied": {
        left: {
            id: "to_lead",
            label: "lead",
            phoneme: "i:"
        },
        right: {
            id: "lied",
            label: "lied",
            phoneme: "aɪ"
        },
    },
    "flea-flye": {
        left: {
            id: "flea",
            label: "flea",
            phoneme: "i:"
        },
        right: {
            id: "flye",
            label: "flye",
            phoneme: "aɪ"
        },
    },
    "team-time": {
        left: {
            id: "team",
            label: "team",
            phoneme: "i:"
        },
        right: {
            id: "time",
            label: "time",
            phoneme: "aɪ"
        },
    },
    "read-ride": {
        left: {
            id: "read",
            label: "read",
            phoneme: "i:"
        },
        right: {
            id: "ride",
            label: "ride",
            phoneme: "aɪ"
        },
    },
    "creed-cried": {
        left: {
            id: "creed",
            label: "creed",
            phoneme: "i:"
        },
        right: {
            id: "cried",
            label: "cried",
            phoneme: "aɪ"
        },
    },
    /* #endregion */

    /* #region /æ/ vs /aɪ/ */
    "sat-sight": {
        left: {
            id: "sat",
            label: "sat",
            phoneme: "æ"
        },
        right: {
            id: "sight",
            label: "sight",
            phoneme: "aɪ"
        },
    },
    "sad-sighed": {
        left: {
            id: "sad",
            label: "sad",
            phoneme: "æ"
        },
        right: {
            id: "sighed",
            label: "sighed",
            phoneme: "aɪ"
        },
    },
    /* #endregion */
}

const OtherPairs: MinimalPairs = {
    /* #region /b/ vs /v/ */
    "sybil-civil": {
        left: {
            id: "sybil",
            label: "sybil",
            phoneme: "b"
        },
        right: {
            id: "civil",
            label: "civil",
            phoneme: "v"
        }
    },
    "bury-very": {
        left: {
            id: "bury",
            label: "bury",
            phoneme: "b"
        },
        right: {
            id: "very",
            label: "very",
            phoneme: "v"
        }
    },
    "verb-verve": {
        left: {
            id: "verb",
            label: "verb",
            phoneme: "b"
        },
        right: {
            id: "verve",
            label: "verve",
            phoneme: "v"
        }
    },
    "trouble-travel": {
        left: {
            id: "trouble",
            label: "trouble",
            phoneme: "b"
        },
        right: {
            id: "travel",
            label: "travel",
            phoneme: "v"
        }
    },
    "saber-saver": {
        left: {
            id: "saber",
            label: "saber",
            phoneme: "b"
        },
        right: {
            id: "saver",
            label: "saver",
            phoneme: "v"
        }
    },
    /* #endregion */

    // /d/ vs /ð/
    "day-they": { // TODO: Improve audio
        left: {
            id: "day",
            label: "day",
            phoneme: "d"
        },
        right: {
            id: "they",
            label: "they",
            phoneme: "ð"
        }
    },

    // /s/ vs /ʃ/
    "sore-shore": {
        left: {
            id: "sore",
            label: "sore",
            phoneme: "s"
        },
        right: {
            id: "shore",
            label: "shore",
            phoneme: "ʃ"
        }
    },

    // /ɑ/ vs /ʌ/

    // /ʌ/ vs /æ/
    "tusk-task": {
        left: {
            id: "tusk",
            label: "tusk",
            phoneme: "ʌ"
        },
        right: {
            id: "task",
            label: "task",
            phoneme: "æ"
        }
    },
    "bluster-blaster": {
        left: {
            id: "bluster",
            label: "bluster",
            phoneme: "ʌ"
        },
        right: {
            id: "blaster",
            label: "blaster",
            phoneme: "æ"
        }
    },

    // /ɪ/ vs /i:/
    "whistle-weasel": {
        left: {
            id: "whistle",
            label: "whistle",
            phoneme: "ɪ"
        },
        right: {
            id: "weasel",
            label: "weasel",
            phoneme: "i:"
        }
    },
}

const Pairs: MinimalPairs = {
    ...MasonPairs,
    ...OtherPairs
};

export default Pairs;